import React from "react";
import { Modal, Button } from "react-bootstrap";

import "./DocumentDeleteErrorModal.css";

const DocumentDeleteErrorModal = ({
  open,
  toggleModal,
  documentName,
  fileType,
}) => {
  const handleClose = () => {
    toggleModal();
  };

  return (
    <>
      <Modal show={open} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Error - Unable to delete document</Modal.Title>
        </Modal.Header>
        <Modal.Body className="deleteDocErr_modalBody">
          The document you are trying to delete (<b>{documentName}</b>) is a
          required document based on your FulFillment Type and
          Platform/Connection Type. If you wish to delete this document, then
          please first upload a replacement under the same document type (
          <b>{fileType}</b>), and then you will be able to delete this document
          using this trash can icon.
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-primary-md" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentDeleteErrorModal;
